import { PublicClientApplication } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: '8adc927c-185e-4499-bb59-e91de32b143d',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin, // Replace with your actual redirect URI
    postLogoutUri: window.location.origin
  },
  cache: {
    cacheLocation: 'sessionStorage'
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);
